import { Form, Formik } from "formik";
import React from "react";

import MyTextArea from "../../../app/common/form/MyTextArea";
import MyTextInput from "../../../app/common/form/MyTextInput";
import * as Yup from "yup";
import { updateUserProfile } from "../../../app/firestore/firestoreService";
import { FormControl } from "@chakra-ui/form-control";
import { Button } from "@chakra-ui/button";
import { Box, Stack } from "@chakra-ui/layout";
import { useToast } from "@chakra-ui/toast";

export default function StreamerSettingsAboutTab({ currentUserProfile }) {
  const toast = useToast();

  return (
    <Box>
      <Formik
        initialValues={{
          streamer_description: currentUserProfile.streamer_description || "",
          twitchchannel: currentUserProfile.twitchchannel || "",
        }}
        validationSchema={Yup.object({
          twitchchannel: Yup.string().max(30),
        })}
        onSubmit={async (values, { setSubmitting }) => {
          try {
            await updateUserProfile(values);
            toast({
              title: "Success",
              streamer_description: "Data has been updated",
              status: "success",
              isClosable: true,
            });
          } catch (error) {
            // toast.error(error.message);
            console.log(error.message);
          } finally {
            setSubmitting(false);
          }
        }}
      >
        {({ isSubmitting, isValid, dirty }) => (
          <Form>
            <FormControl>
              <Stack w='full'>
                <Stack
                  d='flex'
                  w='full'
                  direction={["column", "column", "row"]}
                >
                  <MyTextInput
                    flex='1'
                    name='twitchchannel'
                    label='Your Twitch Channel'
                  />
                </Stack>
                <MyTextArea
                  rows='10'
                  name='streamer_description'
                  label='Description'
                  placeholder='Something about your channel and how do you want to play with your users (games, schedules, focus, etc)...'
                />

                <Button
                  isLoading={isSubmitting}
                  isDisabled={isSubmitting || !isValid}
                  type='submit'
                  variant='primary'
                >
                  Update profile
                </Button>
              </Stack>
            </FormControl>
          </Form>
        )}
      </Formik>
    </Box>
  );
}
